export default {
  defaultStyle: {
    '&:lang(ar)':{
      direction:'rtl'
    }
  },
  moreOptions: {
    textAlign: 'right',
    color: '#fff',
    '@media (min-width: 801px)': {
      display:'table-cell',
      verticalAlign:'middle'
    },
    '&:lang(ar)':{
      textAlign:'left'
    }
  },
  moreOptionsFlex:{
    '@media (min-width: 801px)': {
      display:'flex',
      flexWrap:'nowrap',
      alignItems:'center',
      justifyContent:'flex-end'
    }
  },
  bestPriceContainer: {
    '@media (min-width: 801px)': {
      display: 'inline-block',
      verticalAlign: 'middle',
      font: data => '14px ' + data.fontFamily1,
      letterSpacing: '1px',
      textTransform: 'uppercase',
      paddingLeft: '24px',
      position: 'relative',
      color: '#fff',
    },
    '& > span': {
      verticalAlign: 'middle',
      '@media (min-width: 801px)': {
        paddingLeft:'0'
      }
    },
    '&:lang(ar)':{
      '@media (min-width: 801px)': {
        paddingLeft:'0',
        paddingRight:'24px'
      }
    }
  },
  reservationButton: {
    textTransform: 'uppercase',
    font: data => '14px/13px ' + data.fontFamily1,
    padding: '0 13px 0 27px',
    position: 'relative',
    color: '#fff',
    '&:lang(ar)':{
      paddingRight:'27px',
      paddingLeft:'13px'
    }
  },
  reservationButtonIcon: {
    fontSize: '18px',
    lineHeight: '1px',
    position: 'absolute',
    left: '0',
    top: '50%',
    marginTop: '-1px',
    '&:lang(ar)':{
      left:'auto',
      right:0
    }
  },
  reservationButtonArrow: {
    fontSize: '8px',
    lineHeight: '1px',
    position: 'absolute',
    right: '0',
    top: '50%',
    marginTop: '-2px',
    '&:lang(ar)':{
      right:'auto',
      left:0
    }
  },
  miReservationMobile: {
    marginTop: '10px',
    textAlign: 'right',
    color: '#fff',
    '@media (min-width: 801px)': {
      marginTop: 0,
      display: 'inline-block',
      verticalAlign: 'middle',
      '&:before': {
        '@media (min-width: 801px)': {
          content: "'|'",
          display: 'inline-block',
          verticalAlign: 'middle',
          margin: '0 5px',
          color: data => data.mainColor
        }
      }
    },
    '&:lang(ar)':{
      textAlign:'left'
    }
  }
};
